<template>
    <div class="batch-upload">
        <transition name="fade"> 
            <alart-msg :display="fail.status" styleType="error" @alartStatus="closeAlart">
                <span class="title" slot="title">{{fail.msg}}</span>
            </alart-msg>
        </transition>  
        <batch-house :class="{'fixed': listIsFixed}"></batch-house>
    </div>
</template>
<script>
import BatchHouse from '@/components/bussiness/mgtCategory/houseMgt/batchHouse/BatchHouse.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            alart: this.isFail,
            listIsFixed: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        closeAlart: function () {
            this.$store.commit('batchUpload/set_fail', {status: false, msg: ''})
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            fail: 'GET_BATCH_FAIL'
        })
    },
    components: {
        AlartMsg,
        BatchHouse
    }
}
</script>
<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/BatchUpload.vue